export type PlaceholderKind = "context" | "input" | "textarea" | "break";

export interface IFormPlaceholder {
  /** Token name without braces, e.g. "eventName". */
  name: string;
  /** Full token as written in the template, e.g. "{{eventName}}". */
  token: string;
  /** Bulgarian label shown on the palette chip. */
  label: string;
  kind: PlaceholderKind;
  /** Sample value used for the live preview (context placeholders only). */
  sampleValue?: string;
}

const context = (
  name: string,
  label: string,
  sampleValue: string,
): IFormPlaceholder => ({
  name,
  token: `{{${name}}}`,
  label,
  kind: "context",
  sampleValue,
});

export const CONTEXT_PLACEHOLDERS: IFormPlaceholder[] = [
  context("eventName", "Име на събитието", "Пилатес за начинаещи"),
  context("eventType", "Тип на събитието", "Групово занимание"),
  context("serviceName", "Име на услугата", "Масаж"),
  context("datetime", "Дата и час", "21.07.2026 18:00"),
  context("date", "Дата", "21.07.2026"),
  context("time", "Час", "18:00"),
  context("duration", "Времетраене", "60 мин."),
  context("instructorName", "Име на инструктора", "Иван Петров"),
  context("hallName", "Зала", "Зала 1"),
  // Prices are stored in EUR, so the sample must read as EUR too — otherwise the
  // studio writes "{{price}} евро" against a "20.00 лв." preview and the rendered
  // form contradicts the preview.
  context("price", "Цена", "€ 20.00"),
  context("studioName", "Име на обекта", "Студио „Индиго“"),
  context("studioAddress", "Адрес на обекта", "ул. Пример 1"),
  context("studioPhone", "Телефон на обекта", "0888 123 456"),
  context("studioEmail", "Имейл на обекта", "studio@example.com"),
  context("userName", "Име на потребителя", "Мария Иванова"),
  context("userFirstName", "Собствено име", "Мария"),
  context("userLastName", "Фамилно име", "Иванова"),
  context("userPhoneNumber", "Телефон на потребителя", "0899 654 321"),
  context("userEmail", "Имейл на потребителя", "maria@example.com"),
  context("userBirthday", "Рождена дата", "01.01.1990"),
  context("currentDate", "Днешна дата", "21.07.2026"),
];

export const CONTROL_PLACEHOLDERS: IFormPlaceholder[] = [
  {
    name: "input",
    token: "{{input}}",
    label: "Поле за въвеждане",
    kind: "input",
  },
  {
    name: "textarea",
    token: "{{textarea}}",
    label: "Голямо поле за въвеждане",
    kind: "textarea",
  },
  {
    name: "break",
    token: "{{break}}",
    label: "Нов ред",
    kind: "break",
  },
];

export const ALL_PLACEHOLDERS: IFormPlaceholder[] = [
  ...CONTEXT_PLACEHOLDERS,
  ...CONTROL_PLACEHOLDERS,
];

export const CONTEXT_PLACEHOLDER_NAMES: Set<string> = new Set(
  CONTEXT_PLACEHOLDERS.map((p) => p.name),
);

export const CONTEXT_SAMPLE_VALUES: Record<string, string> =
  CONTEXT_PLACEHOLDERS.reduce<Record<string, string>>((acc, p) => {
    acc[p.name] = p.sampleValue ?? "";
    return acc;
  }, {});
